import { withResetState } from "store/hocs";

import { ownerPrincipalValidationInfoConstants } from "./ownerPrincipalValidationInfo.constants";
import { applicationListConstants } from "../../applicationList/applicationList.constants";

class InitialValidationState {
	isSsnValid = false;
	isSsnBeingValidated = false;
	isSsnValidationPending = false;
	ssnValidationError = "";
}

var initialState = {
	error: "",
	owners: [
		new InitialValidationState(),
		new InitialValidationState(),
		new InitialValidationState(),
		new InitialValidationState(),
	],
	signer: new InitialValidationState(),
};

// Neded bc redux-form doesn't provide with the way to actually trigger async validation
function ownerPrincipalValidationInfo(state = initialState, action) {
	switch (action.type) {
		case applicationListConstants.RESET_APPLICATION_ENTRY_STATE: // That is needed bc state is used in app entry and in the merchant info. Not to mess with state
			return {
				...initialState,
			};

		case ownerPrincipalValidationInfoConstants.REMOVE_OWNER_VALIDATION_INFO:
			return {
				...state,
				owners: [
					...state.owners.filter((x, i) => i !== action.index),
					new InitialValidationState(),
				],
			};
		case ownerPrincipalValidationInfoConstants.REMOVE_SIGNER_VALIDATION_INFO:
			return {
				...state,
				signer: new InitialValidationState(),
			};

		default:
			return state;
	}
}

export default withResetState({ initialState })(ownerPrincipalValidationInfo);
